/**
 * Created by zj on 2017/7/28.
 */
import Component from "../../../../../lib/component";
import template from './calendar.table.body.html';
import './calendar.table.body.scss';
import TableGrid from '../../calendar.subcomponent/calendar.table.grid/calendar.table.grid';

let config = {
    template: template,
    data: {
        currentData: [],
        index: Number,
        isGrid42:true
    },
    actions: {

    },
    afterRender: function() {
        //this.el.css({height:'calc(100%/6)',});
        this.el.addClass('abc');
        this.el.find('#weekNum').attr("id", 'weekNum'+this.data.index);
        let _this=this;
        this.data.currentData.forEach(item => {
	        if(_this.data.specialDays && _this.data.specialDays.length){
		        for(let day of _this.data.specialDays){
		        	if(day.date == item.dataTime){
		        		item.dayName=day.type;
			        }
		        }
			  }
            this.append(new TableGrid({
                data:{bodyData:item, type: 'month',
                isGrid42:this.data.isGrid42,mainContentHeigh:this.data.mainContentHeigh
            }}), this.el.find('#weekNum'+this.data.index));
        });

    }
};

// class CalendarTableBody extends Component {
//     constructor(data, newconfig = {}) {
//         config.data.currentData = data['item']['weekList'];
//         config.data.index = data.index;
//         super($.extend(true ,{}, config, newconfig));
//     }
// }
//
// export default CalendarTableBody;
let CalendarTableBody = Component.extend(config);

export default CalendarTableBody;


// WEBPACK FOOTER //
// app/components/calendar/calendar.main/calendar.month/calendar.table.body/calendar.table.body.js